import { render, staticRenderFns } from "./ErrorBrowserNotValid.vue?vue&type=template&id=77116a28&scoped=true&lang=pug&"
import script from "./ErrorBrowserNotValid.vue?vue&type=script&lang=ts&"
export * from "./ErrorBrowserNotValid.vue?vue&type=script&lang=ts&"
import style0 from "./ErrorBrowserNotValid.vue?vue&type=style&index=0&id=77116a28&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77116a28",
  null
  
)

export default component.exports